// Modal.js
import React, { useState, useEffect } from 'react';

function Modal({ isOpen, onClose, autoHideTimeout, message }) {

    // if (!isOpen) {
    //     return null;
    // }
    // return (
    //     <div className="confirmation-modal">
    //         <div className="confirmation-modal-content">
    //             <p>Quality score : {message} %</p>

    //         </div>
    //     </div>
    // );
    const [visible, setVisible] = useState(isOpen);


    useEffect(() => {
        if (isOpen) {
            setVisible(true);
        }
    }, [isOpen]);
    
    const handleOKClick = () => {
        onClose(); // Close the modal or perform any necessary cleanup
        window.location.href = '/AuditHome'; // Redirect to '/AuditHome'
    };
    
    if (!visible) {
        return null;
    }
    

    // useEffect(() => {
    //     if (isOpen) {
    //         setVisible(true);
    //         const timeoutId = setTimeout(() => {
    //             setVisible(false);
    //             onClose();
    //             window.location.href = '/AuditHome';
    //         }, autoHideTimeout);

    //         return () => {
    //             clearTimeout(timeoutId);
    //         };
    //     }
    // }, [isOpen, onClose, autoHideTimeout]);

    // if (!visible) {
    //     return null;
    // }

    return (

        <div className="confirmation-modal">
            <div className="confirmation-modal-content">
                <h1>Quality Score : {message} %</h1>
                <div style={{textAlign:'center',margin:'10px 0'}}><button onClick={handleOKClick}>OK</button></div>
                {/* <p> {message} %</p> */}

            </div>
        </div>
    );
}

export default Modal;
